import React, {Component} from "react";
import PropTypes from "prop-types";
import Markdown from "react-markdown";
import coreSectionStyles from "./coreSection.module.pcss";
import Column from "./../../../../components/column/column";
import Row from "./../../../../components/row/row";
import contextMenu from "./../../../../../static/images/ContextMenu.png";
import entityView from "./../../../../../static/images/EntityView.png";
import tableView from "./../../../../../static/images/TableView.png";

const CoreSection = ({title, description}) => {

  return (
    <Row
      rowWrapperClassName={coreSectionStyles.coreSection}
      rowContainerClassName={coreSectionStyles.coreSectionContainer}
    >
      <Column customColumnClass={coreSectionStyles.columnTitleDescription}>
        <Markdown source={title}/>
        <Markdown source={description}/>
      </Column>
      <Column customColumnClass={coreSectionStyles.columnGrudImages}>
        <img className={coreSectionStyles.contextMenu} src={contextMenu} alt="ContextMenu" />
        <img className={coreSectionStyles.entityView} src={entityView} alt="EntityView" />
        <img className={coreSectionStyles.tableView} src={tableView} alt="TableView" />
      </Column>
    </Row>
  )
};

CoreSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default CoreSection;


// WEBPACK FOOTER //
// ./src/templates/landing/components/coreSection/coreSections.js